import { z } from 'zod';

const ProposalStatusSchema = z.enum(['WAITING', 'APPROVED', 'COMPLETED', 'REJECTED']);
const ProgressStatusSchema = z.enum(['UPCOMING', 'ONGOING', 'COMPLETED', 'CANCELED']);
const ProposalSortSchema = z.enum([
  'LATEST',
  'OLDEST',
  'BRAND_NAME',
  'HIGH_DISCOUNT',
  'MANY_GOODS',
  'ENDING_SOON',
]);

export const GetProposalsServiceRequestSchema = z
  .object({
    status: ProposalStatusSchema.optional(),
    progressStatus: ProgressStatusSchema.optional(),
    sort: ProposalSortSchema.optional(),
    page: z.number().min(1),
    size: z.number().min(1).max(100),
  })
  .describe('GetProposalsServiceRequestSchema');

export type GetProposalsServiceRequest = z.infer<typeof GetProposalsServiceRequestSchema>;

const CouponResponseSchema = z.object({
  couponNo: z.number(),
  couponName: z.string(),
  couponKeyword: z.string(),
});

export type CouponResponse = z.infer<typeof CouponResponseSchema>;

const ProposalItemSchema = z
  .object({
    campaignProposalId: z.number(),
    brandId: z.string(),
    brandName: z.string(),
    logoUrl: z.string(),
    salesRate: z.number(),
    title: z.string(),
    status: ProposalStatusSchema,
    progressStatus: ProgressStatusSchema,
    couponQuantityLimit: z.number(),
    coupon: CouponResponseSchema.nullable().optional(),
    startAt: z.string(),
    endAt: z.string(),
  })
  .describe('ProposalItemSchema');

export type ProposalItem = z.infer<typeof ProposalItemSchema>;

export const GetProposalsServiceResponseSchema = z.object({
  list: z.array(ProposalItemSchema),
  total: z.number(),
  pagination: z.object({
    currentPage: z.number(),
    pageSize: z.number(),
    hasNextPage: z.boolean(),
    nextPage: z.number().optional(),
  }),
});

export type GetProposalsServiceResponse = z.infer<typeof GetProposalsServiceResponseSchema>;
